import { ItemBoxSkeleton } from '@marketplace-web/item-box/item-box-feature'

const TOTAL_ITEMS = 4

const ItemsGridSkeleton = () => {
  return (
    <div className="item-view-items" data-testid="item-feed-loader">
      {Array.from({ length: TOTAL_ITEMS }).map((_, index) => (
        <div className="item-view-items__item" key={index}>
          <ItemBoxSkeleton />
        </div>
      ))}
    </div>
  )
}

export default ItemsGridSkeleton
